import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { LIBRARY_ITEM_LIMIT } from '#pplx/frontend/apps/ask/queries/thread-queries/constants.js';
import { threadClient } from '#pplx_generated/typespec/rest/thread/client.js';
export const getComputerTasksFromAPI = async ({ paginationParams, timeoutMs, reason, limit, }) => {
    const { data, error, response } = await threadClient.POST('/rest/thread/list_computer_tasks', reason, {
        timeoutMs,
        body: {
            limit: limit ?? LIBRARY_ITEM_LIMIT,
            ascending: false,
            thread_type_filter: 'asi',
            send_last_entry: true,
            include_assets: true,
            ...paginationParams,
        },
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to get computer tasks',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=getComputerTasksFromAPI.js.map